import { Box, Typography } from "@mui/material";
import type { DeliveryPaymentStatus } from "@types_def/models/deliveryPayment.types";

const statusColors: Record<string, string> = {
  PENDING: "#ffc107",
  CANCELLED: "#1b394d",
  FAILED: "#dc3545",
  PAID: "#28a745",
};
const statusText: Record<DeliveryPaymentStatus, string> = {
  PAID: "Payé",
  CANCELLED: "Annulé",
  PENDING: "Transféré",
  FAILED: "Échoué",
};

export const StatusCell = ({ children }: { children?: DeliveryPaymentStatus | null }) => {
  if (!children) {
    return <i>Error</i>;
  }

  const status = children;
  return (
    <Box display="flex" alignItems="center" gap={1}>
      <Box
        sx={{
          width: "0.5rem",
          height: "0.5rem",
          borderRadius: "50%",
          backgroundColor: statusColors[status] || "#ccc",
        }}
      />
      <Typography>{statusText[status]}</Typography>
    </Box>
  );
};
